import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { User, Envelope, Lock, IdentificationCard } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function Register({ school }) {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", contact: "", password: "", role: "orangtua", nis: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const isSdqu = school === "sdqu";

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const c = form.contact.trim();
      const payload = { name: form.name, password: form.password, role: form.role, nis: form.nis, school };
      if (c.includes("@")) payload.email = c; else payload.phone = c;
      await register(payload);
      toast.success("Akun berhasil dibuat!");
      navigate("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen app-bg flex justify-center">
      <div className="w-full md:max-w-md min-h-screen flex flex-col px-6 py-10">
        <h1 className="font-heading text-2xl font-bold text-stone-800 mt-6">Daftar Akun</h1>
        <p className="text-stone-500 text-sm mb-6">Buat akun untuk orang tua</p>

        <motion.form initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} onSubmit={submit} className="space-y-4">
          {form.role === "orangtua" && !isSdqu && (
            <div>
              <div className="relative">
                <IdentificationCard size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
                <input
                  data-testid="register-nis-input"
                  type="text"
                  required
                  value={form.nis}
                  onChange={set("nis")}
                  placeholder="NIS anak (kode akses)"
                  className="w-full bg-white border border-stone-200 rounded-2xl py-4 pl-12 pr-4 outline-none focus:border-primary transition-colors"
                />
              </div>
              <p className="text-xs text-stone-400 mt-1.5 ml-1">Masukkan NIS anak dari pihak sekolah untuk menghubungkan akun ke data anak Anda.</p>
            </div>
          )}
          {[
            { k: "name", icon: User, ph: "Nama lengkap", type: "text" },
            { k: "contact", icon: Envelope, ph: "Email atau No. HP", type: "text" },
            { k: "password", icon: Lock, ph: "Kata sandi", type: "password" },
          ].map(({ k, icon: Icon, ph, type }) => (
            <div className="relative" key={k}>
              <Icon size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-stone-400" />
              <input
                data-testid={`register-${k}-input`}
                type={type}
                required
                value={form[k]}
                onChange={set(k)}
                placeholder={ph}
                className="w-full bg-white border border-stone-200 rounded-2xl py-4 pl-12 pr-4 outline-none focus:border-primary transition-colors"
              />
            </div>
          ))}

          {error && <p data-testid="register-error" className="text-destructive text-sm text-center">{error}</p>}

          <button
            data-testid="register-submit-btn"
            disabled={loading}
            className="w-full bg-primary text-white font-heading font-semibold text-lg py-4 rounded-full shadow-lg shadow-primary/20 active:scale-95 transition-transform disabled:opacity-60"
          >
            {loading ? "Memproses..." : "Daftar"}
          </button>
        </motion.form>

        <p className="text-center text-stone-500 text-sm mt-6">
          Sudah punya akun?{" "}
          <Link to={isSdqu ? "/sdqu-login" : "/login"} className="text-primary font-semibold" data-testid="goto-login-link">Masuk</Link>
        </p>
      </div>
    </div>
  );
}
